<template>
    <div>
        <b-modal
            v-if="disability.images && disability.images.length"
            v-model="showImages"
            centered
            size="xl"
        >
            <template v-slot:modal-footer>
                <b-row class="w-100">
                    <!-- Admin restore-->
                    <b-col v-if="$auth.check('admin')" cols="auto">
                        <b-button v-if="!confirmRestore" :disabled="!isCurrentImageSoftDeleted" variant="primary"
                                  @click="confirmRestore = true"
                        >
                            <fa class="mx-1" icon="recycle" :title="$t('Restore')" />
                            {{ $t('restore image') }}
                        </b-button>
                        <b-button v-if="confirmRestore" variant="primary" @click="restoreImage()">
                            <fa class="mx-1" icon="recycle" :title="$t('Restore')" />
                            {{ $t('confirm restoring image') }}
                        </b-button>
                        <b-button v-if="confirmRestore" @click="confirmRestore = false">
                            {{ $t('cancel') }}
                        </b-button>
                    </b-col>
                    <!-- Admin force delete-->
                    <b-col v-if="$auth.check('admin')">
                        <b-button v-if="!confirmForceDelete" variant="outline-danger"
                                  @click="confirmForceDelete = true"
                        >
                            <fa class="mx-1" icon="times-circle" :title="$t('Delete')" />
                            {{ $t('image force delete') }}
                        </b-button>

                        <b-button v-if="confirmForceDelete" variant="danger" @click="deleteImage(true)">
                            <fa class="mx-1" icon="times-circle" :title="$t('Delete')" />
                            {{ $t('image force delete confirm') }}
                        </b-button>
                        <b-button v-if="confirmForceDelete" @click="confirmForceDelete = false">
                            {{ $t('cancel') }}
                        </b-button>
                    </b-col>

                    <!-- User soft delete-->
                    <b-col cols="auto">
                        <b-button v-if="!confirmSoftDelete" :disabled="isCurrentImageSoftDeleted" variant="danger"
                                  @click="confirmSoftDelete = true"
                        >
                            <fa class="mx-1" icon="trash" :title="$t('Delete')" />
                            {{ $t('image delete') }}
                        </b-button>
                        <b-button v-if="confirmSoftDelete" variant="danger" @click="deleteImage(false)">
                            <fa class="mx-1" icon="trash" :title="$t('Delete')" />
                            {{ $t('image delete confirm') }}
                        </b-button>
                        <b-button v-if="confirmSoftDelete" @click="confirmSoftDelete = false">
                            {{ $t('cancel') }}
                        </b-button>
                    </b-col>
                </b-row>
            </template>
            <b-carousel
                ref="myCarousel"
                :interval="0"
                background="#eee"
                controls
                indicators
                no-animation
                @sliding-start="updateCurrentImageIndex"
            >
                <b-carousel-slide
                    v-for="(image, index) in disability.images"
                    :key="image.id"
                    :caption="$moment(image.created_at).format('ll')"
                    :img-src="image.url"
                >
                    <template v-slot:img>
                        <a
                            :href="image.url"
                            target="_blank"
                        >
                            <img
                                :alt="`${disability.name } ${ $t('image') } ${ index+1 }`"
                                :src="image.url"
                                class="d-block img-fluid"
                            >
                        </a>
                    </template>
                </b-carousel-slide>
            </b-carousel>
        </b-modal>

        <strong class="d-block mb-3">
            <div class="d-flex">
                {{ disability.formatted_string }}

                <b-button
                    v-if="disability.images && disability.images.length"
                    class="ml-auto"
                    size="sm"
                    @click="showImages = true"
                >
                    {{ $t('Show images') }}
                </b-button>
            </div>
        </strong>


        <p v-if="disability.notice" class="mb-0">
            {{ disability.notice }}
        </p>

        <hr>



        <!-- mark as dropped -->
        <template v-if="!dropped">

            <b-button
                class="text-nowrap"
                size="sm"
                variant="success"
                @click="showModal = true"
            >
                {{ $t('Mark as dropped') }}
                <fa class="ml-1" icon="check" />
            </b-button>

            <b-modal
                v-model="showModal"
                :title="$t('Mark as dropped')"
                hide-footer
                @close="form.reset()"
            >
                <b-form @submit.prevent="markAsDropped">
                    <b-form-group
                        :invalid-feedback="form.errors.get('date')"
                        :label="$t('Date')"
                        :label-for="uuid + '_date'"
                        :state="form.errors.has('date') ? false : null"
                    >
                        <b-form-datepicker
                            :id="uuid + '_date'"
                            v-model="form.date"
                            :locale="$i18n.locale"
                            :min="$moment().add(1, 'day').toDate()"
                            :state="form.errors.has('date') ? false : null"
                            class="mb-2"
                            required
                        />
                    </b-form-group>

                    <b-form-group
                        :invalid-feedback="form.errors.get('notice')"
                        :label="$t('Notice')"
                        :label-for="uuid + '_notice'"
                        :state="form.errors.has('notice') ? false : null"
                    >
                        <b-form-textarea
                            :id="uuid + '_notice'"
                            v-model="form.notice"
                            :name="uuid + '_notice'"
                            :state="form.errors.has('notice') ? false : null"
                        />
                    </b-form-group>

                    <b-button :disabled="form.busy" type="submit" variant="primary">
                        {{ $t('Save') }}

                        <b-spinner v-if="form.busy" small />
                        <fa v-else class="ml-1" icon="save" />
                    </b-button>
                </b-form>
            </b-modal>

            <new-images-modal :disability.sync="disability" />
        </template>
        <template v-else>

            <!--drop date -->
            <span>{{ $t('Dropped at', [$moment(disability.drop_date).format('ll')]) }}</span>

            <p v-if="disability.drop_notice">
                {{ disability.drop_notice }}
            </p>

            <!-- revoke mark as dropped -->
            <b-button
                v-if="$gate.allow('revoke', value.disability)"
                class="text-nowrap"
                size="sm"
                variant="warning"
                @click="handleRevokeMarkAsDropped"
            >
                {{ $t('Revoke mark as dropped') }}
                <fa class="ml-1" icon="recycle" />
            </b-button>
        </template>
    </div>
</template>
<script>
import Form from 'vform';
import NewImagesModal from "@/components/disabilities/NewImagesModal";

export default {
    name: 'DisabilityListItem',
    components: {NewImagesModal},
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            showImages: false,
            disability: this.value,
            showModal: false,
            form: new Form({
                date: this.$moment().format('YYYY-MM-DD'),
            }),
            currentImageIndex: 0,
            confirmSoftDelete: false,
            confirmForceDelete: false,
            confirmRestore: false,
        };
    },

    computed: {
        apiUrl() {
            return `/api/rooms/${this.disability.room_id}/disabilities/${this.disability.disability_id}`
        },
        dropped() {
            return !!this.disability.drop_date;
        },
        isCurrentImageSoftDeleted() {
            return !!this.currentlyViewedImage().pivot.deleted_at;

        }
    },
    watch: {
        value(newValue) {
            this.disability = newValue
        },
        showImages(){
            this.currentImageIndex = 0;
            this.$refs.myCarousel.setSlide(0)
        },
        currentImageIndex(){
            this.confirmSoftDelete = false
            this.confirmForceDelete = false
            this.confirmRestore = false
        },

    },
    methods: {
        currentlyViewedImage() {
            return this.disability.images[this.currentImageIndex] ?? null;
        },
        updateCurrentImageIndex(event){
            this.currentImageIndex = event
        },
        deleteImage(force){
            this.pending = true;

            const params = {};
            if (force) {
                params['force'] = true;
            }

            this.axios.delete(
                this.apiUrl + "\\images\\" + this.currentlyViewedImage().id,{params})
                .then(function(data) {
                    this.$set(this, 'disability', data.data)

                }.bind(this))
                .catch(e => {
                    if (!e.response) {
                        throw e;
                    }
                    if (e.response.status === 404) {
                        this.onNotFound();
                    }
                })
                .finally(() => {
                    this.pending = false
                    this.confirmSoftDelete = false
                    this.confirmForceDelete = false

                    if (this.currentImageIndex > 0){
                        this.currentImageIndex--
                    }
                })
        },
        restoreImage(){
            this.pending = true;
            this.axios.post(
                this.apiUrl + "\\images\\" + this.currentlyViewedImage().id + "\\restore")
                .then(function (data){
                    this.$set(this, 'disability', data.data)
                }.bind(this))
                .catch(e => {
                    if (!e.response) {
                        throw e;
                    }
                    if (e.response.status === 404) {
                        this.onNotFound();
                    }
                })
                .finally(() => {
                    this.pending = false
                    this.confirmRestore = false
                });
        },
        async markAsDropped() {
            try {
                await this.form.post(this.apiUrl);

                this.showModal = false;
                this.$set(this.disability, 'drop_date', this.form.date);
                this.$set(this.disability, 'drop_notice', this.form.notice);
            } catch (e) {
                if (!e.response) {
                    throw e;
                }
            }
        },
        async handleRevokeMarkAsDropped() {
            this.$bvModal.msgBoxConfirm(this.$t('Are you sure you want to revoke this disability as dropped?'), {
                title: this.$t('Are you sure?'),
                okVariant: 'danger',
                okTitle: this.$t('Yes'),
                cancelTitle: this.$t('No'),
                hideHeaderClose: false,
                centered: true
            }).then(confirmed => {
                if (confirmed){
                    this.axios.post(this.apiUrl + '/revoke').then(() => {
                            this.$set(this.disability, 'drop_date', null);
                            this.$set(this.disability, 'drop_notice', null);
                        }).catch(e => e.response || throw e)
                }
            })

        },
    }
};
</script>
<style scoped>
>>> .carousel-caption {
    text-shadow: 2px 2px 0px var(--dark);
}
</style>
